import styled from "styled-components";

export const TablePageContainer = styled.div`
  background: ${({ theme }) => theme.semanticColors.bgSurfaceDefault};
  max-width: 100%;
  overflow: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  /* Remove right padding to eliminate extra spacing on product cards */
  padding-right: 0;
  /* Remove bottom padding to fix scrolling issue where filter border doesn't touch bottom */
  padding-bottom: 0;
`;

export const ToolbarContainer = styled.div`
  position: sticky;
  top: 0;
  background: ${({ theme }) => theme.semanticColors.bgSurfaceDefault};
  z-index: 2;
`;

export const TableContentWrapper = styled.div`
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
  .table-with-bulk-action {
    height: 100%;
    overflow: auto;
  }
`;
